import { Easing, Tween } from '@tweenjs/tween.js';
import { EVENTS } from '../../lib/constants';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import HELPERS from '../../lib/globals/helpers/Helpers';
import AnimateEntrance from '../helper/animate';
const events = [
	EVENTS.MODAL,
	EVENTS.SERVER_MSG,
	EVENTS.ERROR_PAGE,
	EVENTS.BONUS_BUY,
	EVENTS.BET_UPDATE
];

class AutoSpinController {
	constructor(vc, conf) {
		this.vc = vc;
		this.config = conf;
		if (this.vc.auto_spin_bg.getChildByName(this.config.item, true)) {
			this.item = this.vc.auto_spin_bg.getChildByName(this.config.item, true);
			this.item.interactive = true;
			this.item.handler = this.startAuto;
			this.interaction = true;
			this.timeout = null;
			this.enabled = true;
			AnimateEntrance(this.vc);
			for (let i = 0; i < events.length; i++) {
				window.addEventListener(events[i], this, false);
			}
			if (
				GameConfigs.settings.keyboard_shortcuts &&
				!window.isMobile &&
				!window.isTablet
			) {
				window.addEventListener('keydown', this, false);
			}
			if (this.timeout) {
				clearTimeout(this.timeout);
			}
			this.timeout = setTimeout(() => {
				//add event after a small delay when the component is rendered
				window.addEventListener(EVENTS.INTERACTION, this, false);
			}, 100);
		} else {
			throw new Error(
				'CloseController failed init ' + JSON.stringify(this.config)
			);
		}
	}

	handleEvent(evt) {
		switch (evt.type) {
			case EVENTS.BET_UPDATE:
				this.interaction = false;
				break;

			case EVENTS.MODAL:
				if (evt.detail.modal !== 'auto_spin') {
					window.removeEventListener(EVENTS.INTERACTION, this, false);
					this.removeEvents();
				}
				break;
			case EVENTS.ERROR_PAGE:
				if (evt.detail.error) {
					window.removeEventListener(EVENTS.INTERACTION, this, false);
					this.removeEvents();
				}
				break;
			case EVENTS.BONUS_BUY:
				if (evt.detail.bonus) {
					window.removeEventListener(EVENTS.INTERACTION, this, false);
					this.removeEvents();
				}
				break;
			case 'keydown':
				if (
					evt.keyCode === 27 ||
					(evt.keyCode === 32 && !GameConfigs.disabled.spin)
				) {
					if (GameConfigs.modal === 'auto_spin') {
						HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: '' });
					}
					window.removeEventListener(EVENTS.INTERACTION, this, false);
					this.removeEvents();
				}
				break;
			case EVENTS.INTERACTION:
				const target = this.vc[this.config.holder].getBounds();
				if (GameConfigs.modal === 'auto_spin') {
					if (
						HELPERS.handleOutsideClick(
							target,
							evt.x,
							evt.y,
							'auto_spin',
							this.interaction
						)
					) {
						window.removeEventListener(EVENTS.INTERACTION, this, false);
						this.removeEvents();
					} else {
						this.interaction = true;
					}
				}
				break;
			case EVENTS.SERVER_MSG:
				if (evt.detail.service === 'bet') {
					if (evt.detail.data.bonuswin) {
						window.removeEventListener(EVENTS.INTERACTION, this, false);
						this.removeEvents();
					}
				}
				break;
			default:
				break;
		}
	}
	removeEvents() {
		if (this.timeout) {
			clearTimeout(this.timeout);
		}
		this.item.interactive = false;
		window.removeEventListener(EVENTS.INTERACTION, this, false);
		window.removeEventListener('keydown', this, false);
		for (let i = 0; i < events.length; i++) {
			window.removeEventListener(events[i], this, false);
		}
	}

	animateDisable() {
		if (this.tween) {
			this.tween = null;
		} else {
			window.sm.play({ name: 'error_sfx' });
			this.tween = new Tween(this.item.bg)
				.to({ x: 5 }, 10)
				.yoyo(true)
				.repeat(5)
				.easing(Easing.Linear.None)
				.start();
		}
	}

	startAuto = () => {
		if (this.enabled) {
			if (GameConfigs.reelComponent.rotating) {
				this.animateDisable();
				return;
			}
			this.enabled = false;
			GameConfigs.autospin.isAutoOn = true;
			HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: '' });
			HELPERS.dispatchCustomEvent(EVENTS.AUTO_STARTED, {
				numOfBets: GameConfigs.autospin.numOfBets,
				isAutoOn: GameConfigs.autospin.isAutoOn,
				leftBets: 0,
				pause: false
			});
		}
	};
}

export default AutoSpinController;
